import React from "react";

const Contact = ({ theme }) => {
  const accentBg = theme === "dark" ? "bg-[#1c1f2b] text-white" : "bg-gray-100 text-black";

  return (
    <section id="contact" className={`${accentBg} w-full py-16 px-4`}>
      <div className="max-w-md mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-8">Contact Us</h2>
        <form className="space-y-4">
          <input type="text" placeholder="Your Name" className="w-full px-4 py-2 rounded border dark:border-gray-600 bg-gray-100 dark:bg-[#1e293b] dark:text-white" aria-label="Your Name" />
          <input type="email" placeholder="Your Email" className="w-full px-4 py-2 rounded border dark:border-gray-600 bg-gray-100 dark:bg-[#1e293b] dark:text-white" aria-label="Your Email" />
          <textarea placeholder="Your Message" className="w-full px-4 py-2 rounded border dark:border-gray-600 bg-gray-100 dark:bg-[#1e293b] dark:text-white" aria-label="Your Message" />
          <button className="w-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded shadow transition">Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;